/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardPaymentResultFilterViewModel } from "../types/CreditCardPaymentResultFilterViewModel.ts";

export const creditCardPaymentResultFilterViewModelSchema = z.object({
  startDate: z.string().nullish(),
  endDate: z.string().nullish(),
  companyId: z.number().int().nullish(),
  classStudents: z.string().nullish(),
  studentName: z.string().nullish(),
  cpf: z.string().nullish(),
  approved: z.number().int().nullish(),
  merchant: z.string().nullish(),
  serial: z.number().int().nullish(),
  transactionCode: z.string().nullish(),
  sortField: z.string().nullish(),
  sortDirection: z.string().nullish(),
}) as unknown as ToZod<CreditCardPaymentResultFilterViewModel>;
